/*
* Copyright (C) Regione Lombardia
*/
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
    AnagraficaComuni,
    DatalistAnagrafica,
    FormDataSessionEnum,
    Paginator, Rilievo, Sorting,
    SortingDirectionEnum
} from '@models';
import { RilievoService } from '@shared/services/rilievo.service';
import { UtilsService } from '@shared/services/utils.service';

@Component({
    selector: 'app-pages-gestione-rilievo-ricerca-progetto',
    templateUrl: './ricerca-rilievo.component.html',
})
export class PagesGestioneRilievoRicercaRilievoComponent implements OnInit {

    public criteriaForm: FormGroup;
    public tableData: Rilievo[] = [];
    public tableSort: Sorting[] = [];
    public paginator: Paginator = new Paginator();
    public comuniFiltered: AnagraficaComuni[] = [];
    public datalist: DatalistAnagrafica;

    constructor(
        private rilievoService: RilievoService,
        private utilsService: UtilsService,
        private fb: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
    ) { }

    ngOnInit() {
        this.tableSort = [
            { field: 'idRilievo', direction: SortingDirectionEnum.DESC },
        ];
        this._initForm();
    }

    public goToRilievo(idRilievo: number) {
        this.router.navigate(['../dettaglio', idRilievo], { relativeTo: this.route });
    }

    public submitForm(fromBtn?: boolean) {
        if(fromBtn) {
            this.paginator.resetPaginator();
        }
        if(this.criteriaForm.get('dataInizioRilievo')?.value && this.criteriaForm.get('dataFineRilievo')?.value &&(new Date(this.criteriaForm.get('dataInizioRilievo')?.value).getTime() > new Date(this.criteriaForm.get('dataFineRilievo')?.value).getTime())) {
            this.utilsService.showWarning('La data di inizio rilievo dev\'essere minore di quella di fine.');
            return;
        }
        this.utilsService.setFormDataSession(FormDataSessionEnum.RILIEVO_RICERCA, this.criteriaForm.getRawValue());
        
        this.rilievoService.search(this.criteriaForm.getRawValue(), this.paginator.getQueryPaginator(this.tableSort)).subscribe(response => {
            this.tableData = response.content;
            this.paginator.setTotalPage(response.totalElements);
        });
    }

    public resetForm() {
        this.paginator.resetPaginator();
        this.tableData = [];
        this.criteriaForm.reset();
        this.utilsService.setFormDataSession(FormDataSessionEnum.RILIEVO_RICERCA, this.criteriaForm.getRawValue());
    }

    public onPageChange($event: number) {
        this.paginator.page = $event;
        this.submitForm();
    }

    private _initForm() {
        this.criteriaForm = this.rilievoService.generateFormRicercaRilievo();
        const formDataSession = this.utilsService.getFormDataSession(FormDataSessionEnum.RILIEVO_RICERCA);
        if (formDataSession) {
            this.criteriaForm.patchValue(formDataSession);
            this.submitForm();
        }
    }


}
